import { FC } from 'react';
import { CmsCta } from 'src/types/cms/cmsFieldTypes';
import { CmsActionGrid, CmsActionGridItem } from 'src/types/cms/cmsWidgetTypes';
import HomeWidget from './HomeWidget';

type Props = {
  widget?: CmsActionGrid | null;
  redirect: (action?: CmsCta) => void;
};
const Template_4: FC<Props> = ({ widget, redirect }) => {
  return (
    <>
      {widget?.actionGridItems.map((widgetData: CmsActionGridItem, index) => {
        return <HomeWidget key={index} widgetData={widgetData} redirect={redirect} cls={''} />;
      })}
    </>
  );
};
export default Template_4;
